import { createSlice } from '@reduxjs/toolkit';
import { IAgentAvailabilityState } from '../constants/types';

const initialState: IAgentAvailabilityState = {
  error: '',
  loading: false,
  agentAvailabilityData: [],
  lastUpdatedAt: '',
  radioOption: 'All',
  historyLoading: false,
  agentAvailablityHistoryData: [],
  tlDetails: [],
  reporteesDetails: []
};

const AgentAvailabilitySlice = createSlice({
  name: 'AgentAvailabilitySlice',
  initialState,
  reducers: {
    setApiResponse(state, action) {
      const { agentAvailabilityData, lastRefreshedTimeStamp } = action.payload;
      state.agentAvailabilityData = agentAvailabilityData;
      state.lastUpdatedAt = lastRefreshedTimeStamp;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setAgentAvailablityHistoryData(state, action) {
      const { agentAvailablityHistoryData } = action.payload;
      state.agentAvailablityHistoryData = agentAvailablityHistoryData;
    },
    setHistoryLoading(state, action) {
      state.historyLoading = action.payload;
    },
    setRadioOption(state, action) {
      state.radioOption = action.payload;
    },
    setAgentAvailabilityLists(state, action) {
      const { tlDetails, reporteesDetails } = action.payload;
      state.tlDetails = tlDetails;
      state.reporteesDetails = reporteesDetails;
    },
    clearAgentAvailabilityData(state) {
      state.agentAvailabilityData = [];
      state.lastUpdatedAt = '';
    }
  }
});

export const {
  setLoading,
  setApiResponse,
  setRadioOption,
  setAgentAvailablityHistoryData,
  setHistoryLoading,
  setAgentAvailabilityLists,
  clearAgentAvailabilityData
} = AgentAvailabilitySlice.actions;

export default AgentAvailabilitySlice.reducer;
